export default __webpack_public_path__ + "static/media/notif_add_comment.25b11a4c.svg";